const uiReducerInitialState = {
  action: "show",
  saving: false,
  member_updated_at: null,
  generalModal: {
    show: false
  },
  errorModal: {
    show: false,
    errors: {}
  },
  documentModal: {
    show: false,
  }
};

const uiReducer = (state = uiReducerInitialState, action) => {
  switch (action.type) {
    case "TOGGLE_ACTION":
      return {...state, action: state.action == "show" ? "edit" : "show"};
    case "OPEN_RESOURCE_MODAL":
      return {
        ...state,
        [`${action.payload.resourceName}Modal`]: {
          ...state[`${action.payload.resourceName}Modal`],
          show: true
        }
      }
    case "CLOSE_RESOURCE_MODAL":
      return {
        ...state,
        [`${action.payload.resourceName}Modal`]: {
          ...state[`${action.payload.resourceName}Modal`],
          show: false
        }
      }
    case "NEW_RESOURCE":
      return {
        ...state,
        [`${action.payload.resourceName}Modal`]: {
          ...state[`${action.payload.resourceName}Modal`],
          [action.payload.resourceName]: {},
          action: "new",
          show: true
        }
      }
    case "EDIT_RESOURCE":
      return {
        ...state,
        [`${action.payload.resourceName}Modal`]: {
          ...state[`${action.payload.resourceName}Modal`],
          [action.payload.resourceName]: action.payload.resource,
          action: "edit",
          show: true
        }
      }
    case "UPDATE_RESOURCE_FIELD":
      return {
        ...state,
        [`${action.payload.resourceName}Modal`]: {
          ...state[`${action.payload.resourceName}Modal`],
          [action.payload.resourceName]: {
            ...state[`${action.payload.resourceName}Modal`][action.payload.resourceName],
            [action.payload.name]: action.payload.value
          }
        }
      }
    case "UPDATE_MEMBER_UPDATED_AT":
      return {
        ...state,
        member_updated_at: action.payload.member_updated_at
      }
    case "UPDATE_SAVING":
      return {
        ...state,
        saving: action.payload.saving
      }
    case "UPDATE_ERRORS": {
      return {
        ...state,
        errorModal: {
          ...state.errorModal,
          errors: action.payload.errors
        }
      }
    }
    default:
      return state;
  };
};

export default uiReducer;
